import { createSelector } from '@reduxjs/toolkit';

export const getAllStaffState = (state) => state.staffAll;
export const getStaffState = (state) => state.staff;

export const getAllStaff = createSelector(getAllStaffState, (allStaffState) => allStaffState.data);

export const getStaff = createSelector(getStaffState, (staffState) => staffState.data);
